const filters = [
  {
    service: {
      folder: 'bibliotecas',
      file: 'Bibliotecas',
      relationship: ''
    },
    listLabel: 'biblioteca',
    label: 'Biblioteca',
    itemValue: 'id',
    itemText: 'apelido',
    id: 'includes[biblioteca][id]'
  }
]

export default filters
